import React, { useState, useEffect, useRef } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import { CheckCircleFill, XCircleFill, Copy } from "react-bootstrap-icons";

import axiosInstance from "utils/axiosInstance";

import "./styles.css";

const Invites = () => {
    const [invites, setInvites] = useState([]);
    const [copiedToken, setCopiedToken] = useState(null);
    const buttonRefs = useRef({});

    const fetchItems = async () => {
        try {
            const response = await axiosInstance.get('/api/user/invites');
            return response.data;
        } catch (error) {
            return [];
        }
    };

    useEffect(() => {
        fetchItems().then((data) => {
            const sorted = [...data.data].sort((a, b) => a.used - b.used);
            setInvites(sorted);
        });
    }, []);

    const copyToken = (token, e) => {
        navigator.clipboard.writeText(token);
        e.currentTarget.blur();
        setCopiedToken(token);
        setTimeout(() => setCopiedToken(null), 1000);
    };

    return (
        <>
            <div className="mt-4">
                <table className="table table-sm align-middle">
                    <thead>
                        <tr>
                            <th>Token</th>
                            <th className="text-center">Used</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {invites.map((invite) => (
                            <tr key={invite.token}>
                                <td>
                                    <code className="text-muted">{invite.token}</code>
                                </td>
                                <td className="text-center">
                                    {invite.used
                                        ? <CheckCircleFill className="text-success" />
                                        : <XCircleFill className="text-secondary" />
                                    }
                                </td>
                                <td className="text-end">
                                    <button
                                        ref={(el) => buttonRefs.current[invite.token] = el}
                                        className={`btn btn-sm ${copiedToken === invite.token ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                        onClick={(e) => copyToken(invite.token, e)}
                                    >
                                        <Copy size={12} />
                                    </button>
                                    <Overlay
                                        target={buttonRefs.current[invite.token]}
                                        show={copiedToken === invite.token}
                                        placement="top"
                                    >
                                        <Tooltip>Copied!</Tooltip>
                                    </Overlay>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default Invites;